(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('ContactForm');
    var emailField = document.getElementById('ContactForm-email');
    var submitButton = form && form.querySelector('button[type="submit"]');

    if (!form || !emailField || !submitButton) return;

    var fieldWrapper = emailField.closest('.field');
    var errorId = 'ContactForm-custom-email-error';

    function showRequiredError() {
      removeRequiredError();

      if (fieldWrapper) {
        fieldWrapper.classList.add('field--with-error');
      }

      emailField.setAttribute('aria-invalid', 'true');
      emailField.setAttribute('aria-describedby', errorId);

      var error = document.createElement('div');

      error.id = errorId;
      error.className = 'custom-email-required-error';
      error.textContent = 'Email is required';

      if (fieldWrapper) {
        fieldWrapper.appendChild(error);
      }

      emailField.focus();
    }

    function removeRequiredError() {
      var error = document.getElementById(errorId);

      if (error) {
        error.remove();
      }

      if (fieldWrapper) {
        fieldWrapper.classList.remove('field--with-error');
      }

      emailField.removeAttribute('aria-invalid');
      emailField.removeAttribute('aria-describedby');
    }

    /*
     * ONLY handle an empty email field.
     *
     * If the email contains any value, this code does nothing.
     * Therefore Shopify/browser keeps its normal invalid-email
     * validation for values such as "xyz".
     */
    submitButton.addEventListener('click', function (event) {
      if (emailField.value.trim() === '') {
        event.preventDefault();
        showRequiredError();
      }
    });

    /*
     * Remove the custom error as soon as the user starts typing.
     */
    emailField.addEventListener('input', function () {
      if (emailField.value.trim() !== '') {
        removeRequiredError();
      }
    });

    /*
     * Remove the error if the user clicks another field.
     */
    emailField.addEventListener('blur', function () {
      if (emailField.value.trim() !== '') {
        removeRequiredError();
      }
    });
  });

  /*
   * Styling
   */
  var style = document.createElement('style');

  style.textContent = `
    

    /* Required error message */
    #ContactForm .custom-email-required-error {
      display: block;
      position: absolute;
      left: 0;
      top: calc(100% + 1px);
      z-index: 20;
      background: #fff;
      color: #000;
      padding: 6px 0;
      font-size: 14px;
      line-height: 0.4;
    }

    /* Keep the error positioned relative to the email field */
    #ContactForm .field.field--with-error {
      position: relative;
    }
  `;

  document.head.appendChild(style);
})();